<template>
    <common-content-spacer height="small">
        <common-page-header
            :heading="$t('modals.make_direct_referal_modal.invite.heading', { name: name })"
            :content="$t('modals.make_direct_referal_modal.invite.content')"
            :isCenter="true"
            contentSpacing="medium"
            size="minor"
        ></common-page-header>
        <common-content-wrapper width="small">
            <form-wrapper @submit="submit(data)">
                <form-row class="email-collector--name-row">
                    <form-cell width="half">
                        <text-field
                            :label="$t('elements.network.email_collector.first_name')"
                            :placeholder="$t('elements.network.email_collector.first_name')"
                            :formData="data"
                            :isRequired="true"
                            valuePath="firstName"
                            errorPath="firstName.0"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>

                    <form-cell width="half">
                        <text-field
                            :label="$t('elements.network.email_collector.last_name')"
                            :placeholder="$t('elements.network.email_collector.last_name')"
                            :formData="data"
                            :isRequired="true"
                            valuePath="lastName"
                            errorPath="lastName.0"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>
                <form-row>
                    <form-cell>
                        <text-field
                            :label="$t('forms.auth.login.fields.email.label')"
                            :placeholder="$t('forms.auth.login.fields.email.placeholder')"
                            :isRequired="true"
                            :formData="data"
                            :error="errorMessage"
                            valuePath="email"
                            errorPath="emails.0"
                            type="email"
                            @change="change($event)"
                        ></text-field>
                    </form-cell>
                </form-row>

                <template #footer>
                    <common-buttons>
                        <common-button
                            :isProcessing="isSending"
                            :label="$t('pages.referrals.new.dropdown.label.create_referral')"
                            :isDisabled="!isSendDataButtonAvailable"
                            type="primary"
                        ></common-button>
                    </common-buttons>
                </template>
            </form-wrapper>
        </common-content-wrapper>
    </common-content-spacer>
</template>

<script>
    import FormMixin from 'mixins/FormMixin'
    import UsersAPI from 'api/UsersAPI'

    export default {
        mixins: [FormMixin],

        props: {
            name: { type: String, required: true },
            isDisabled: { type: Boolean, required: false, default: false },
        },

        data() {
            return {
                isSending: false,
                errorMessage: null,
            }
        },

        computed: {
            isSendDataButtonAvailable() {
                return this.data.email && this.data.firstName && this.data.lastName
            },
        },

        methods: {
            submit(data) {
                this.errorMessage = null
                this.isSending = true
                UsersAPI.checkRegistrationEmail({ email: data.email })
                    .then(() => {
                        this.isSending = false
                        if (this.$validation.get('email')) {
                            this.$validation.clear()
                        }
                        this.emitEvent({ name: 'proceed-to-referral-creation', payload: data })
                    })
                    .catch((error) => {
                        this.errorMessage = error.response.data[0].message
                        this.isSending = false
                        this.triggerAutofocusInput()
                    })
            },
        },
    }
</script>
